export class CustomFont {
  Id: string;
  Name: string;
  FallBackFontName: string;
  FontUrl: string;
  FontFamily: string;
}

export class CustomFonts {
  fonts: CustomFont[] = [];
}
